/**
 * TEMPORARY (EMS-10766): the enrollment-overlap audit UI. Delete this whole
 * folder, its entry in enrollment-platform/routes.ts and the sidebar tab in
 * components/SideNav/link-data.js to remove the feature.
 */
export const ENROLLMENT_OVERLAP = 'enrollment-overlap'

export const enrollmentOverlapPath = (): string => `/${ENROLLMENT_OVERLAP}`

export const enrollmentOverlapRunPath = (runId: string): string =>
  `/${ENROLLMENT_OVERLAP}/${encodeURIComponent(runId)}`

export const enrollmentOverlapEmployeePath = (
  runId: string,
  employeePublicKey: string
): string =>
  `${enrollmentOverlapRunPath(runId)}/employees/${encodeURIComponent(
    employeePublicKey
  )}`

/**
 * The existing employee enrollments screen, where overlapping enrollments are
 * edited. It lives outside this feature (the fix itself is out of scope here).
 */
export const employeeEnrollmentsPath = (employeePublicKey: string): string =>
  `/employees/${encodeURIComponent(employeePublicKey)}/enrollments`
